import { render, staticRenderFns } from "./remits.vue?vue&type=template&id=a04eb4b4&scoped=true&"
import script from "./remits.vue?vue&type=script&lang=js&"
export * from "./remits.vue?vue&type=script&lang=js&"
import style0 from "./remits.vue?vue&type=style&index=0&lang=css&"
import style1 from "./remits.vue?vue&type=style&index=1&id=a04eb4b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04eb4b4",
  null
  
)

export default component.exports